<div class="generate-dialog-content">
    <div class="subtitle">Select the customer(s) you'd like to generate a price sheet for.</div>

    <div class="tags-dropdown">
        <app-multiselect *ngIf="isComponentReady"
                        [label]="tagsLabel"
                        [placeholder]="tagsPlaceholder"
                        [selectedItems]="selectedTags"
                        [AllItems]="tags"
                        [AddNewItemEnabled]="false"
                        (onChange)="onTagSelection($event)">
        </app-multiselect>
    </div>

    <div class="dialogContent">
        <app-group-analytics-generate-dialog-grid 
            [groupDistributionGridData]="dataSources" 
            (customerSelectedClicked)="customerSelectedClicked($event)" 
            (selectAllClicked)="onSelectAllClicked($event)" 
            (manuallyCheckedChanged)="onManuallyCheckedChanged($event)">
        </app-group-analytics-generate-dialog-grid>
    </div>
    <div class="dialog-actions">
        <button (click)="onGenerate()"
                [disabled]="
                !selectedCustomers ||
                !selectedCustomers.length ||
                downloading ||
                emailing
            "
                color="accent"
                mat-raised-button>
            {{ !downloading ? "Generate and Download" : "" }}
            <mat-spinner *ngIf="downloading" diameter="20"></mat-spinner>
        </button>
        <button (click)="onEmail()"
                [disabled]="
                !selectedCustomers ||
                !selectedCustomers.length ||
                emailing ||
                emailing
            "
                color="green"
                mat-raised-button>
            {{ !emailing ? "Email Pricing" : "" }}
            <mat-spinner *ngIf="emailing" diameter="20"></mat-spinner>
        </button>
    </div>
</div>
